import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  id: "container",
  style: {"display":"flex"}
}
const _hoisted_3 = {
  class: "mediaContainer",
  id: "mediaContainer"
}
const _hoisted_4 = {
  key: 0,
  class: "video",
  id: "video",
  autoplay: "",
  playsinline: ""
}
const _hoisted_5 = {
  key: 1,
  class: "video",
  id: "recvVideo",
  autoplay: "",
  muted: "",
  playsinline: ""
}
const _hoisted_6 = {
  key: 2,
  id: "recvAudio",
  autoplay: ""
}
const _hoisted_7 = { class: "leftListContainer" }
const _hoisted_8 = { class: "leftList" }
const _hoisted_9 = { class: "leftListItemName" }
const _hoisted_10 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_12 = { class: "buttonContainer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("开始直播")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("开始直播")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HanButtonVue = _resolveComponent("HanButtonVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isHosting)
          ? (_openBlock(), _createElementBlock("video", _hoisted_4))
          : _createCommentVNode("", true),
        (!_ctx.isHosting)
          ? (_openBlock(), _createElementBlock("video", _hoisted_5))
          : _createCommentVNode("", true),
        (!_ctx.isHosting)
          ? (_openBlock(), _createElementBlock("audio", _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "leftListItem",
              key: user.id
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(user.nickname ? user.nickname : "游客") + " ", 1),
                (user.nickname === _ctx.nickname)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_10, "(我)"))
                  : _createCommentVNode("", true),
                (user.isHosting)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_11, " 正在分享屏幕"))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.hasProducer)
          ? (_openBlock(), _createBlock(_component_HanButtonVue, {
              key: 0,
              color: "blue",
              onClick: _ctx.goLive
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isHosting)
          ? (_openBlock(), _createBlock(_component_HanButtonVue, {
              key: 1,
              color: "blue",
              onClick: _ctx.playAudio1
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}